import { makeAutoObservable } from 'mobx'
import type { ISurveyCommonData } from 'entities/Surveys/model/types'
import { type IResponseGetSurvey, type SurveysStatus } from 'entities/Surveys/api/types'

export class SurveySmall {
  id: IResponseGetSurvey['id']
  name: IResponseGetSurvey['name']
  status: IResponseGetSurvey['status']
  total_sent: IResponseGetSurvey['total_sent'] = 0
  valid_replies: IResponseGetSurvey['valid_replies'] = 0
  invalid_replies: IResponseGetSurvey['invalid_replies'] = 0
  undelivered: IResponseGetSurvey['undelivered'] = 0
  expired: IResponseGetSurvey['expired'] = 0
  nps_score: IResponseGetSurvey['nps_score'] = 0
  created_at: IResponseGetSurvey['created_at'] = ''

  constructor(response: IResponseGetSurvey) {
    this.id = response.id
    this.name = response.name
    this.status = response.status
    this.total_sent = response.total_sent
    this.valid_replies = response.valid_replies
    this.invalid_replies = response.invalid_replies
    this.undelivered = response.undelivered
    this.expired = response.expired
    this.nps_score = response.nps_score
    this.created_at = response.created_at

    makeAutoObservable(this)
  }

  syncOrigin = (response: IResponseGetSurvey) => {
    this.name = response.name
    this.status = response.status
    this.total_sent = response.total_sent
    this.valid_replies = response.valid_replies
    this.invalid_replies = response.invalid_replies
    this.undelivered = response.undelivered
    this.expired = response.expired
    this.nps_score = response.nps_score
    this.created_at = response.created_at
  }

  get validRepliesPercent() {
    if (!this.total_sent) return 0
    return Math.round((this.valid_replies / this.total_sent) * 100)
  }

  get invalidRepliesPercent() {
    if (!this.total_sent) return 0
    return Math.round((this.invalid_replies / this.total_sent) * 100)
  }

  get undeliveredPercent() {
    if (!this.total_sent || this.undelivered === null) return 0
    return Math.round((this.undelivered / this.total_sent) * 100)
  }

  get expiredPercent() {
    if (!this.total_sent || this.expired === null) return 0
    return Math.round((this.expired / this.total_sent) * 100)
  }

  get data(): ISurveyCommonData {
    return {
      id: this.id,
      name: this.name,
      status: this.status,
    }
  }

  setStatus = (value: SurveysStatus) => {
    this.status = value
  }
}
